export default __webpack_public_path__ + "29daba7fd1728035a7128e17cb257562.png";